module.exports = __webpack_public_path__ + "img/2_6.ca8f510f.png";